import React from "react";
import Newsletter_48 from "../component/Newsletter_48";

function Newsletter_48_container() {
  return <Newsletter_48 />;
}

export default Newsletter_48_container;
